import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import styles from './settings-text-section.module.css';

type Props = {
    label: string;
    subtitle?: string;
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
};

export function SettingsTextSection(props: Props) {
    return (
        <div className={styles.section}>
            <Stack spacing={2}>
                <Stack isHorizontal={true} spacing={2}>
                    <Body size='small' color='medium' isBold={true}>
                        {props.label}
                    </Body>
                    <Body size='small' color='error'>
                        *
                    </Body>
                </Stack>
                {props.subtitle && (
                    <Body size='small' color='light'>
                        {props.subtitle}
                    </Body>
                )}
            </Stack>
            <TextField
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
                rows={3}
                multiline={true}
                borderVariant='ai-purple'
            />
        </div>
    );
}
